import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function MobileCTABar() {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    let active = true;
    const check = async (uid: string | null) => {
      if (!uid) { if (active) setIsAdmin(false); return; }
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", uid)
        .in("role", ["admin", "super_admin"])
        .maybeSingle();
      if (active) setIsAdmin(!!data);
    };
    supabase.auth.getSession().then(({ data }) => check(data.session?.user.id ?? null));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => check(s?.user.id ?? null));
    return () => { active = false; sub.subscription.unsubscribe(); };
  }, []);
  if (isAdmin) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden flex border-t border-white/10 bg-[#050505]/90 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]">
      <a
        href="tel:6088864598"
        aria-label="Call Michael's Painting"
        className="flex-1 py-4 text-center text-xs font-semibold text-zinc-200 border-r border-white/10 uppercase tracking-[0.2em] min-h-[56px] inline-flex items-center justify-center active:bg-white/5"
      >
        Call Now
      </a>
      <a
        href="/#estimate"
        aria-label="Request a free estimate"
        className="flex-1 py-4 text-center text-xs font-semibold bg-gradient-to-r from-amber-500 to-yellow-500 text-white uppercase tracking-[0.2em] min-h-[56px] inline-flex items-center justify-center active:brightness-95"
      >
        Free Estimate
      </a>
    </div>
  );
}